/* 
Object:         NodeMove
Description:    Logic and events for node move
Used in:        NodeMove
*/

import * as appsettings from "../appsettings";
import * as main        from "../main";
import * as navigation  from "../navigation";


let newParentNodeId = -1;                                       // Current selected nodeid
let expand_initial_treeview_nodeid = new Array();               // Expand towards a particulair node in the nodetree after loading
let titleError: string, textError: string, textOk: string;      // Error messages


/**
* Select node (event raised when selecting a node in the kendo node tree). Only nodes that are not disabled by the css class are selectable. 
* @param {kendo.ui.TreeViewSelectEvent} e
*/
export function selectNode(e: kendo.ui.TreeViewSelectEvent): void {
    if ($(e.node).hasClass('node-tree-item-disabled')) {
        e.preventDefault();
    }
    else {
        newParentNodeId = Number($(e.node).find('.data-id').val());
    }
}

/**
* OnDataBound event (used to expand to a particular path (selected node in the current session.)).
*/
export function onDataBound(): void {
    // Get treeNode.
    const treeview = $("#nodemove-node-tree-precom").data("kendoTreeView");

    // navigate (this ensures that the onDataBound is called many times...)
    treeview.expandPath(expand_initial_treeview_nodeid, function () { });

    // Opacity
    $(".node-tree-item-disabled").parent().parent().css("opacity", 0.2);
}

/**
* Initialize.
*/
export function initialize(jsonStr: NodeTreeNavigationItemVM[], titleErrorParam: string, textErrorParam: string, textOkParam: string): void {

    let titleError = titleErrorParam;
    let textError = textErrorParam;
    let textOk = textOkParam;

    // Format and set it ready for method: expandPath.
    let arr: number[] = [];

    //
    for (let i = 0; i < jsonStr.length; i++) {
        arr.push(jsonStr[i].NodeId);
    }

    // 
    expand_initial_treeview_nodeid = arr;

    // event apply move
    $("#applyMove").on("click", function () {

        if (newParentNodeId != -1) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("NodeMove/Move"),
                data: { newParentNodeId: newParentNodeId },
                success: function (responseData: responseModel|undefined|null) {

                    if (responseData.Succesfully) {
                        // reload nodetree
                        navigation.setFirstLoadPage(true);
                        navigation.refreshNodeTree();
                    }
                    else {
                        main.openActionsDialog(titleError,
                            textError, [{
                                text: textOk,
                                action: function () {
                                    main.closePopup();
                                }, primary: true
                            }]);
                    }
                }
            });
        }

    });
}
